import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { Subscription } from 'rxjs';
import { Cari } from 'src/model/cari';
import { MailRequest } from 'src/model/mail-request';
import { Master } from 'src/model/master';
import { RestService } from 'src/providers/rest.service';
import Swal from 'ngx-angular8-sweetalert2';

declare var $: any;

@Component({
  selector: 'app-cari-kayit-modal',
  templateUrl: './cari-kayit-modal.component.html',
  styleUrls: ['./cari-kayit-modal.component.css'],
})
export class CariKayitModalComponent implements OnInit {
  @ViewChild('modalForm') public modalForm: NgForm;

  private subscriptions: Subscription[] = [];

  modalData: number = null;
  sehirler: Master[] = null;
  paraBirimleri: Master[] = null;
  cari: Cari = new Cari();
  mailGonder: boolean = false;
  onayMailGonder: boolean = false;
  isPublic: boolean = false;
  aktarimHidden: boolean = true;
  accessKey: string;

  @Output() yeniCari = new EventEmitter<Cari>();

  @Input()
  public set show(ts: number) {
    if (ts) {
      if (this.modalData !== ts) {
        this.modalData = ts;
        // this.reset();
        $('#cari-kayit-modal').modal('show');
      }
    }
  }
  constructor(
    private restService: RestService,
    private toastrService: ToastrService,
    private route: ActivatedRoute
  ) {}

  ngOnInit() {
    this.subscriptions.push(
      this.route.queryParams.subscribe((params) => {
        if (params.key) {
          this.restService.cariAccess(params.key).subscribe((res) => {
            if (res.id) {
              this.cari = res;
              this.isPublic = true;

              // console.log(this.cari.publicAccessKey)

              $('#cari-kayit-modal').modal('show');

              if (params.action) {
                if (params.action === 'onay') {
                  this.aktarimHidden = false;
                }

                if (res.isAktarildi) this.aktarimHidden = true;
              } else {
                this.onayMailGonder = true;
              }
            }
          });
        }
      })
    );

    const types = [Master.Sehir, Master.ParaBirimi];

    this.restService.getMasterTypes(types).subscribe((res) => {
      this.sehirler = res?.Sehir?.map((x) => new Master(x));
      this.paraBirimleri = res?.ParaBirimi?.map((x) => new Master(x));
    });
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  async cariKaydet() {
    //UI validator
    if (!this.suitableCari()) return;

    // BackEnd validator
    const tcVergi = this.cari.tcNo ? this.cari.tcNo : this.cari.vergiNo;
    const which = this.cari.tcNo ? 0 : 1;

    this.restService.cariBul(tcVergi, which).subscribe((res) => {
      if (res !== 0) {
        // existing Cari
        Swal.fire(
          'Oops...',
          'Bu TC No veya Vergi No ile Cari kaydı bulunmaktadır.!',
          'error'
        );
      } else {
        if (this.cari.id === null) {
          if (
            (this.mailGonder || this.onayMailGonder) &&
            (this.cari.mailAdresi === '' || this.cari.firmaUnvani === '')
          ) {
            alert('Mail adresi ve firma ünvanı zorunludur!');
            return;
          }

          if (this.onayMailGonder && this.mailGonder) {
            this.toastrService.error(
              'Sadece onay maili ya da sadece bilgi formu gönderebilirsiniz!',
              'Uyarı'
            );
            return;
          }

          this.restService.cariEkle(this.cari).subscribe((res) => {
            // this.toastrService.show("Kaydedildi", "Başarılı");
            if (res) {
              this.accessKey = res.publicAccessKey;

              if (this.mailGonder) {
                const mailRequest = new MailRequest();
                mailRequest.toEmail = res.mailAdresi;
                mailRequest.subject = 'CARİ BİLGİ FORMU';
                mailRequest.template = MailRequest.CARI_BILGI_FORMU;
                mailRequest.name = res.firmaUnvani;
                mailRequest.publicAccessKey = this.accessKey;

                this.restService.mailGonder(mailRequest).subscribe((res2) => {
                  // if (!res) {
                  //   this.toastrService.error("Mail gönderilirken hata oluştu");
                  // }
                });
              } else if (this.onayMailGonder) {
                this.onayMailiGonder(this.accessKey);
              }

              this.yeniCari.emit(res);

              $('#cari-kayit-modal').modal('hide');
              this.modalForm.form.reset();
            }
          });
        } else {
          this.restService.cariDuzenle(this.cari).subscribe((res) => {
            if (res) {
              this.accessKey = res.publicAccessKey;
              this.toastrService.success('Kaydedildi', 'İşlem Başarılı!');
              this.onayMailiGonder(this.accessKey);
            } else this.toastrService.error('Hata Oluştu', 'İşlem Başarısız!');
          });
        }
      }
    });
  }

  netsiseAktar() {
    // if (this.cari.cariKodu !== "") {
    //   if (this.cari.cariKodu.length <= 16) {
    if (this.cari.vergiNo === '' && this.cari.tcNo === '') {
      this.toastrService.warning(
        'Vergi no ya da Tc No doldurulmalıdır.',
        'Uyarı'
      );
      return;
    }

    if (this.cari.vergiNo !== '') {
      if (this.cari.vergiNo.length !== 10) {
        this.toastrService.warning('Vergi no 10 haneli olmalı.', 'Uyarı');
        return;
      }
    }

    if (this.cari.tcNo !== '') {
      if (this.cari.tcNo.length !== 11) {
        this.toastrService.warning('Tc Kimlik no 11 haneli olmalı.', 'Uyarı');
        return;
      }
    }

    this.restService.cariDuzenle(this.cari).subscribe((res) => {
      if (res) {
        this.restService.netsisCariKaydet(res).subscribe((res) => {
          this.aktarimHidden = true;
          this.toastrService.success('Cari Netsise Aktarıldı!', 'Başarılı');
        });
      } else
        this.toastrService.error('Cari kaydedilirken hata oluştu!', 'Hata');
    });
    // }
    // else
    //   this.toastrService.error("Cari kodu en fazla 15 karakter olabilir!", "Uyarı");
    // }
    // else
    //   this.toastrService.error("Cari kodu boş geçilemez!", "Uyarı");
  }

  onayMailiGonder(accessKey: string) {
    const mailRequest = new MailRequest();
    // mailRequest.toEmail = res.mailAdresi;
    mailRequest.subject = 'CARİ ONAY FORMU';
    mailRequest.template = MailRequest.CARI_ONAY_FORMU;
    mailRequest.name = this.cari.firmaUnvani;
    mailRequest.publicAccessKey = accessKey;

    this.restService.mailGonder(mailRequest).subscribe((res2) => {
      // if (!res2) {
      //   this.toastrService.error("Mail gönderilirken hata oluştu");
      // }
    });
  }

  suitableCari() {
    //empty control
    if (!this.cari.mailAdresi) {
      Swal.fire('Oops...', 'E-posta adresi boş olamaz!', 'error');
      return false;
    }
    if (!this.cari.firmaAdresi) {
      Swal.fire('Oops...', 'Firma adresi boş olamaz!', 'error');
      return false;
    }

    if (!this.cari.ibanNo) {
      Swal.fire('Oops...', 'IBAN boş olamaz!', 'error');
      return false;
    }

    if (!this.cari.firmaUnvani) {
      Swal.fire('Oops...', 'Firma ünvanı boş olamaz!', 'error');
      return false;
    }
    if (!this.cari.vergiDairesi) {
      Swal.fire('Oops...', 'Vergi Dairesi boş olamaz!', 'error');
      return false;
    }
    //************ */

    //mail regex
    if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(this.cari.mailAdresi)
    ) {
      Swal.fire('Oops...', 'Lütfen uygun bir e-posta adresi giriniz.', 'error');
      return false;
    }

    //tcNo and vergiNo and vergiDairesi combine
    if (
      (this.cari.vergiNo && this.cari.tcNo) ||
      (!this.cari.vergiNo && !this.cari.tcNo)
    ) {
      Swal.fire(
        'Oops...',
        'Yalnızca TC veya Vergi No Giriniz. İkiside dolu veya boş olamaz.!',
        'error'
      );
      return false;
    }

    if (
      this.cari.vergiNo &&
      !this.cari.tcNo &&
      this.cari.vergiNo.length !== 10
    ) {
      Swal.fire('Oops...', 'Vergi No 10 haneli olmalıdır.', 'error');
      return false;
    }

    if (this.cari.tcNo && !this.cari.vergiNo && this.cari.tcNo.length !== 11) {
      Swal.fire('Oops...', 'TC No 11 haneli olmalıdır.', 'error');
      return false;
    }

    if (this.cari.tcNo && !this.tcValidator(this.cari.tcNo)) {
      Swal.fire('Oops...', 'Lütfen geçerli bir TC No giriniz.', 'error');
      return false;
    }

    return true;
  }

  tcValidator(tc: String) {
    let sum = 0;
    for (let i = 0; i < tc.length - 1; i++) {
      const digit = parseInt(tc[i]);
      if (Number.isNaN(digit)) return false;

      sum += digit;
    }

    return sum % 10 === parseInt(tc[tc.length - 1]);
  }
}
